import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant" // instant scroll prevents visual lag
    });
  }, [pathname]);

  return null;
}

export default ScrollToTop;
